import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import type { LangCode } from './locales-config';
import { allLangs, getCurrentLang } from './locales-config';

export function useLocales() {
  const { i18n } = useTranslation();

  const currentLang = getCurrentLang(i18n.resolvedLanguage);

  const onChangeLang = useCallback(
    (lang: LangCode) => {
      i18n.changeLanguage(lang);
    },
    [i18n]
  );

  return { allLangs, currentLang, onChangeLang };
}
